<div class="loader-overlay" *ngIf="loaderService.isLoading$ | async">
  <img src="assets/img/logo/chameleon-walk-final.gif">
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>